export default __webpack_public_path__ + "static/media/coursesCSVExample.3c02b66e.PNG";